export enum UrlParamType {
  Owner = 'dogowner',
  Borrower = 'borrower',
  Pro = 'pro',
}

export const getUrlParamIsOwner = (isOwner: boolean): UrlParamType =>
  isOwner ? UrlParamType.Owner : UrlParamType.Borrower

export type APIRoute = {
  path: string
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'
}

export type APIRouteFunc = (...params: any[]) => APIRoute

export interface APIRequestConfig<
  RequestBodyType extends Record<string, unknown> | FormData = never,
  RequestUrlPathParams extends Record<string, string> = never,
  RequestUrlSearchParams extends Record<string, unknown> = never,
> extends Omit<RequestInit, 'body' | 'method'> {
  body?: RequestBodyType
  searchParams?: RequestUrlSearchParams
  urlPathParams?: RequestUrlPathParams
}
